var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 21.4001L12.6334 13.5334C11.9667 14.0889 11.2001 14.5223 10.3334 14.8334C9.46674 15.1445 8.60007 15.3001 7.73341 15.3001C5.57785 15.3001 3.76141 14.5609 2.28408 13.0827C0.805853 11.6054 0.0667419 9.80005 0.0667419 7.66672C0.0667419 5.53339 0.805853 3.72761 2.28408 2.24939C3.76141 0.772052 5.56674 0.0333862 7.70007 0.0333862C9.83341 0.0333862 11.6445 0.772052 13.1334 2.24939C14.6223 3.72761 15.3667 5.53339 15.3667 7.66672C15.3667 8.60005 15.2001 9.50005 14.8667 10.3667C14.5334 11.2334 14.1001 11.9667 13.5667 12.5667L21.5001 20.5001C21.6112 20.6112 21.6667 20.7503 21.6667 20.9174C21.6667 21.0836 21.589 21.2445 21.4334 21.4001C21.3001 21.5334 21.1503 21.6001 20.9841 21.6001C20.817 21.6001 20.6556 21.5334 20.5001 21.4001ZM7.73341 13.9667C9.48896 13.9667 10.9779 13.3614 12.2001 12.1507C13.4223 10.9392 14.0334 9.4445 14.0334 7.66672C14.0334 5.88894 13.4223 4.39427 12.2001 3.18272C10.9779 1.97205 9.48896 1.36672 7.73341 1.36672C5.95563 1.36672 4.45563 1.97205 3.23341 3.18272C2.01119 4.39427 1.40008 5.88894 1.40008 7.66672C1.40008 9.4445 2.01119 10.9392 3.23341 12.1507C4.45563 13.3614 5.95563 13.9667 7.73341 13.9667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bf7564b374253049dcff34456bafcb2f.svg";
export { ForwardRef as ReactComponent };